export default __webpack_public_path__ + "static/media/18_2.33f72610.jpg";